$(document).ready(function() {

	$(window).scroll(function () {
		sessionStorage.scrollPos = $(window).scrollTop();
	});

	$('div#my-box').on('scroll', function () {
		sessionStorage.scrollPosMB = $('div#my-box').scrollTop();
	});

	if (dsUtilities.url_param('scroll') == '1') {
		$(window).scrollTop(sessionStorage.scrollPos || 0);
		$('div#my-box').scrollTop(sessionStorage.scrollPosMB || 0);
	}

	/*** NAVIGATION ***/
	$('a.acc-orders-nav[data-logged="1"]').on( 'click', function () {
		$('a.info-nav').removeClass('info-show');
		if ($(this).hasClass('info-show')) {
			$('#acc-orders-nav').hide();
			$(this).removeClass('info-show');
		} else {
			$('#acc-orders-nav').show();
			$(this).addClass('info-show');
		}
		$('#info-nav').hide();
	});

	$('#acc-orders-nav .close').on( 'click', function () {
		$('#acc-orders-nav').toggle();
	});

	$('a.info-nav').on( 'click', function () {
		$('a.acc-orders-nav').removeClass('info-show');
		if ($(this).hasClass('info-show')) {
			$('#info-nav').hide();
			$(this).removeClass('info-show');
		} else {
			$('#info-nav').show();
			$(this).addClass('info-show');
		}
		$('#acc-orders-nav').hide();
	});

	$(document).mouseup(function(e) {
		if (!$(e.target).hasClass('info-nav') && !$(e.target).hasClass('acc-orders-nav')) {
			const account_nav = $('div#acc-orders-nav'),
				info_nav = $('div#info-nav');
			if (account_nav.css('display') === 'block') {
				account_nav.hide();
			}
			if (info_nav.css('display') === 'block') {
				info_nav.hide();
			}
			$('a.acc-orders-nav, a.info-nav').removeClass('info-show');
		}
	});

	$(window).on("scroll load", function () {
		const scrollPos = $(this).scrollTop(),
			headerH = $('.header').innerHeight();
		if(scrollPos>headerH) {
			$('.mini-header').removeClass('scroll_hidden');
		} else {
			$('.mini-header').addClass('scroll_hidden');
		}
	});

	let myBoxButton = $('.my-box__button'),
		myBoxMobile = $('.mobile-nav__item--my-box'),
		myBoxField = $('.my-box__field');
	myBoxButton.on('click', function () {
		if (myBoxButton.hasClass('on')) {
			myBoxButton.removeClass('on');
			myBoxField.addClass('hide');
		} else {
			myBoxButton.addClass('on');
			myBoxField.removeClass('hide');
		}
	});
	myBoxMobile.on('click', function () {
		if (myBoxField.hasClass('hide')) {
			myBoxField.removeClass('hide');
		} else {
			myBoxField.addClass('hide');
		}
	});

	/*** MODAL ***/
	let modalPostcode = $('.modal__postcode'),
		modalOrder = $('.modal__complete-order'),
		modal = $('.modal'),
		body = $('body');
	modalPostcode.on('click', function () {
		modalPostcode.addClass('hide');
		modalOrder.removeClass('hide');
	});
	modalOrder.on('click', function () {
		modalOrder.addClass('hide');
		modal.addClass('hide');
		body.removeClass('no-scroll');
	});

	let headerAccount = $('.header__top__account');
	headerAccount.on('click', function () {
		if ($('.modal__lhs-menu').hasClass('hide')) {
			$('.modal__lhs-menu').removeClass('hide');
		} else {
			$('.modal__lhs-menu').addClass('hide');
		}
	});

	$('.modal__lhs-menu__remove').on('click', function () {
		$('.modal__lhs-menu').addClass('hide');
	});

	$('.mobile-nav__item--account').on('click', function () {
		if ($('.modal__lhs-menu').hasClass('hide')) {
			$('.modal__lhs-menu').removeClass('hide');
		} else {
			$('.modal__lhs-menu').addClass('hide');
		}
	});

	$('div#mobile-nav .more').on('click', function () {
		$('div#info-nav').toggleClass('menu-show');
		$('div.my-box-hidden').removeClass('my-box-show');
		$('div.my-box-mobile-modal').removeClass('show');
		$('div#acc-orders-nav, div#lhs-categories-menu').removeClass('menu-show');
	});

	$('div.nav_container a.close').on('click', function() {
		$(this).parent().parent().removeClass('menu-show');
	});

	$('div#lhs-categories-menu img.close').on('click', function() {
		$(this).parent().removeClass('menu-show');
	});

	$('div.my-box').on('click', function () {
		if (!$('div#my-box').length) {
			location.href = dsUtilities.urlShop(true);
		} else {
			$('div.my-box-hidden').toggleClass('my-box-show');
			$('div.my-box-mobile-modal').toggleClass('show');
			$('#lhs-categories-menu, #acc-orders-nav, div#info-nav').removeClass('menu-show');
		}
	});

	$('div#mobile-nav div.categories').on('click', function () {
		$('div#lhs-categories-menu').toggleClass('menu-show');
		$('div#acc-orders-nav, div#info-nav').removeClass('menu-show');
		$('div.my-box-hidden').removeClass('my-box-show');
		$('div.my-box-mobile-modal').removeClass('show');
		$('div.mobile-nav-bg').fadeOut(100);
	});

	$('div#mobile-nav div.account').on('click', function () {
		if ($(this).attr('data-logged') === '1') {
			$('div#acc-orders-nav').toggleClass('menu-show');
			$('div#lhs-categories-menu, div#info-nav').removeClass('menu-show');
			$('div.my-box-hidden').removeClass('my-box-show');
			$('div.my-box-mobile-modal').removeClass('show');
			$('div.mobile-nav-bg').fadeOut(100);
		} else {
			location.href = dsUtilities.urlLogin();
		}
	});

	$('div#footer div.items').on('click', function () {
		if (window.innerWidth <= 1023) {
			$(this).children('div').slideToggle();
		}
	});

	if (doorstep.page_type === 'home' && $(window).width() >= 1024) {
		if ($('div#acc-orders-nav').length) {
			$('div#acc-orders-nav').css({ top:'4.5rem', right: '19.5rem'});
		}
		if ($('div#info-nav').length) {
			$('div#info-nav').css('top', '4.5rem');
			$('div#info-nav').css('right', doorstep.customer.id === null ? '25rem' : '29rem');
		}
	}

});
